module.exports = __webpack_public_path__ + "img/banner.638882bf.jpg";